import produce from "immer";
import {
  FETCH_CONTACTS,
  FETCH_CONTACTS_SUCCESS,
  FETCH_CONTACTS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_CONTACTS,
  ADD_CONTACTS_SUCCESS,
  ADD_CONTACTS_FAILURE,
  //
  EDIT_CONTACTS,
  EDIT_CONTACTS_SUCCESS,
  EDIT_CONTACTS_FAILURE,
  //
  DELETE_CONTACTS,
  DELETE_CONTACTS_SUCCESS,
  DELETE_CONTACTS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingContact: false,
  contacts: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentContact: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
};

const ContactReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_CONTACTS:
        draft.isFetchingContact = true;
        draft.contacts = [];
        break;
      case FETCH_CONTACTS_SUCCESS:
        draft.isFetchingContact = false;
        draft.contacts = action.payload;
        break;
      case FETCH_CONTACTS_FAILURE:
        draft.isFetchingContact = false;
        draft.contacts = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentContact = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentContact = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentContact = {};
        break;
      // Add
      case ADD_CONTACTS:
        draft.isSubmitting = true;
        break;
      case ADD_CONTACTS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_CONTACTS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_CONTACTS:
        draft.isSubmitting = true;
        break;
      case EDIT_CONTACTS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_CONTACTS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_CONTACTS:
        draft.isDeleting = true;
        break;
      case DELETE_CONTACTS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_CONTACTS_FAILURE:
        draft.isDeleting = false;
        break;
      default:
        return state;
    }
  });

export default ContactReducer;
